export default __webpack_public_path__ + "static/media/f_wdt_c_2.1cbeca0b.mp3";